import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import { useDropzone } from "react-dropzone";
import "./dropzone.css";
import bgImage from "./assets/dropzoneBGImage.png";
import DATA_PRODUCTS from "./DATA_PRODUCTS";
import OpacityContext from "./OpacityContext";

const baseStyle = {
  outline: "#f5f5f5 dashed 2px",
  position: "absolute"
};

const acceptStyle = {
  boxShadow: "0px 0px 8px 1px #00e676",
  position: "absolute"
};

const rejectStyle = {
  boxShadow: "0px 0px 8px 1px #ff1744",
  position: "absolute"
};
const dzBackgroundImage = {
  width: "100%",
  height: "100%",
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "absolute",
  zIndex: "100"
};

function DropzoneSVG(props) {
  const { productIndex, shakeDropzoneBGImage, svgFile } = useContext(
    OpacityContext
  );
  // Use assetFileToChange prop if provided, otherwise fallback to context svgFile
  const assetFile = props.assetFileToChange || svgFile;

  /////////////////////////////  files accepted and message on mouse over

  const acceptedFileTypeString = props.acceptedFileTypeString;
  const acceptedFileTypeMessageString = getHintString(acceptedFileTypeString);
  const droppedFileType = props.droppedFileType;

  const ref = useRef(null);

  const handleWarningMessageText = (txt, useIcon) => {
    props.handleWarningMessageText(txt, useIcon);
  };

  function getHintString(str) {
    let newString = str.split(",");
    let stringArrayMap = newString.map(function(value) {
      let split = value.split("/");
      return split[1];
    });
    return "accepted files: " + stringArrayMap.join(", ");
  }

  //////////////////////////////

  const [showHint, setShowHint] = useState(false);

  // all this does is determine which preview div to display, image or video
  const [mediaType, setMediaType] = useState("image");

  // this is where dropped files are added
  // only used for preview
  const [files, setFiles] = useState([]);

  useEffect(() => {
    // Only run if assetFile.payload is a valid File or Blob
    if (
      Object.keys(assetFile).length > 0 &&
      Object.keys(files).length === 0 &&
      acceptedFileTypeString === "image/svg+xml" &&
      assetFile.payload &&
      (assetFile.payload instanceof File || assetFile.payload instanceof Blob)
    ) {
      console.log("populate it");
      const elem = document.createElement("img");
      elem.src = URL.createObjectURL(assetFile.payload);
      const el = ref.current;
      el.innerHTML = "";
      el.appendChild(elem);
    }
    // create an img with assetFile.payload as the source
  }, [assetFile, acceptedFileTypeString, files]);

  // Helper to check if droppedFileType is any SVG type
  const isSVGType = type =>
    ["svg", "svg-landscape", "svg-portrait"].includes(type);

  const validateDroppedFile = (w, h) => {
    const expectedPixelsE = DATA_PRODUCTS.data[productIndex].pixels.ePixels;
    const expectedPixelsL = DATA_PRODUCTS.data[productIndex].pixels.lPixels;
    const expectedPixelsP = DATA_PRODUCTS.data[productIndex].pixels.pPixels;

    const expectedSizeE =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.eSizes;
    const expectedSizeL =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.lSizes;
    const expectedSizeP =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.pSizes;
    let expectedPixels;

    droppedFileType === "elevator"
      ? (expectedPixels = expectedPixelsE)
      : droppedFileType === "landscape"
      ? (expectedPixels = expectedPixelsL)
      : (expectedPixels = expectedPixelsP);

    let acceptedSizes;

    droppedFileType === "elevator"
      ? (acceptedSizes = expectedSizeE)
      : droppedFileType === "landscape"
      ? (acceptedSizes = expectedSizeL)
      : (acceptedSizes = expectedSizeP);

    const receivedPixels = w * h;
    console.log("expected = ", expectedPixels);
    console.log("received = ", receivedPixels);

    const exists = Object.values(expectedPixels).includes(receivedPixels);

    if (isSVGType(droppedFileType) || droppedFileType === "standardAd") {
      handleWarningMessageText("", false);
      return true;
    } else if (exists) {
      console.log("right size");
      handleWarningMessageText("", false);
      return true;
    } else {
      handleWarningMessageText(
        `dropped file is wrong size. Requred dimensions: ${acceptedSizes}`,
        true
      );
      console.log("wrong size, droppedFileType:", droppedFileType);
      setFiles([]);

      handleDropzoneChanges("payload", null);

      return false;
    }
  };

  const handleDropzoneChanges = (name, value) => {
    // dropped file type = elevator, landscape, portrait, standard, svg.
    // this writes the name/value pair to the approprate dropped file in app.js
    props.handleDropzoneChanges(name, value, props.droppedFileType);
  };

  //* removed these two vars from the below const object for useDropzone(): acceptedFiles, fileRejections, isDragActive,
  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject
  } = useDropzone({
    maxFiles: 1,
    noClick: false,
    multiple: false,
    accept: acceptedFileTypeString,

    onDropRejected: rejectedFiles => {
      console.log("rejected");
      handleWarningMessageText("wrong file type dropped.", true);
    },

    // accepted files are ones that are the correct file type.  File size is checked later
    onDropAccepted: acceptedFiles => {
      console.log("1 files ", files);
      console.log("1 accepted ", acceptedFiles);
      // {file, preview} is put in state of files
      // this does not seem to put anything in state FILES.  it puts the preview in the acceptedFiles
      setFiles(
        acceptedFiles.map(myfile =>
          Object.assign(myfile, {
            preview: URL.createObjectURL(myfile)
          })
        )
      );
      console.log("2 files ", files);
      console.log("2 accepted ", acceptedFiles);

      // get width and height of preview
      // this value is 0 when a file out of the accepted list is dropped
      const newFile = acceptedFiles[0];
      const nameArray = newFile.name.split(".");
      const ext = nameArray[nameArray.length - 1];

      if (ext === "mp4") {
        setMediaType("video");
      } else {
        setMediaType("image");
      }

      if (ext !== "mp4") {
        console.log("not mp4 and acceptFiles = ", acceptedFiles);
        // accepted files has name, type, preview blob
        console.log("not mp4 and files = ", files);
        // files is still zero
        const i = new Image();
        i.onload = () => {
          console.log("i loaded");
          let reader = new FileReader();
          reader.readAsDataURL(newFile);
          reader.onload = () => {
            console.log("reader loaded");

            const droppedFileIsCorrectSize = validateDroppedFile(
              i.width,
              i.height
            );
            if (droppedFileIsCorrectSize) {
              console.log("image and correct");

              handleDropzoneChanges("name", newFile.name);
              handleDropzoneChanges("payload", newFile);
              handleDropzoneChanges("width", i.width);
              handleDropzoneChanges("height", i.height);
              handleDropzoneChanges("type", newFile.type);
              handleDropzoneChanges("size", newFile.size);
            }
          };
        };

        i.src = newFile.preview;
      } else {
        // need to interrogate video for its secrets
        const video = document.createElement("video");
        video.addEventListener("canplay", event => {
          const droppedFileIsCorrectSize = validateDroppedFile(
            video.videoWidth,
            video.videoHeight
          );
          if (droppedFileIsCorrectSize) {
            handleDropzoneChanges("payload", newFile);
            handleDropzoneChanges("width", video.videoWidth);
            handleDropzoneChanges("height", video.videoHeight);
            handleDropzoneChanges("type", newFile.type);
            handleDropzoneChanges("size", newFile.size);
            handleDropzoneChanges("name", newFile.name);
          }
        });
        video.src = URL.createObjectURL(newFile);
      }
    }
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragAccept, isDragReject]
  );

  // put the map function back in here
  // If files is empty but assetFile exists, show assetFile as preview
  const svgImagePreview =
    files.length === 0 &&
    assetFile &&
    assetFile.payload &&
    (assetFile.payload instanceof File || assetFile.payload instanceof Blob) ? (
      <img
        key={assetFile.name || "svg-preview"}
        src={URL.createObjectURL(assetFile.payload)}
        style={{ width: "100%" }}
        alt="preview"
      />
    ) : (
      files.map(file => (
        <img
          key={file.name}
          src={URL.createObjectURL(files[0])}
          style={{ width: "100%" }}
          alt="preview"
        />
      ))
    );

  const imagePreview = files.map(file => (
    <img
      key={file.name}
      src={URL.createObjectURL(files[0])}
      style={{ width: "100%" }}
      alt="preview"
    />
  ));

  const videoPreview = files.map(file => (
    <video key={file.name} autoPlay loop style={{ width: "100%" }}>
      <source src={URL.createObjectURL(files[0])} />
    </video>
  ));

  return (
    <div
      className="dropzoneImageGrandParent"
      onMouseEnter={() => setShowHint(true)}
      onMouseLeave={() => setShowHint(false)}
    >
      {showHint ? (
        <div className="dropzoneHint">{acceptedFileTypeMessageString}</div>
      ) : null}
      <div {...getRootProps({ style })} className="dropZone">
        <div className="droppedImageHolder">
          {Object.keys(files).length === 0 ? (
            <div
              style={dzBackgroundImage}
              className={`dzBackgroundImage ${
                shakeDropzoneBGImage ? "shakeIt" : ""
              }`}
            ></div>
          ) : null}
          <div ref={ref} className="dropzoneImageParent">
            {mediaType === "video"
              ? videoPreview
              : isSVGType(droppedFileType)
              ? svgImagePreview
              : imagePreview}
          </div>
        </div>

        <input {...getInputProps()} />
      </div>
    </div>
  );
}
export default DropzoneSVG;
